import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  Icon,
} from "@mui/material";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import { useNavigate } from "react-router-dom"; // ✅ added import

const SkillCard = () => {
  const navigate = useNavigate(); // ✅ for navigation

  const handlePlayNow = () => {
    navigate("/ga-fps"); // ✅ redirect to your Unity game page
  };

  return (
    <Card
      sx={{
        backgroundColor: "#1A1A1A",
        borderRadius: "16px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
        maxWidth: 320,
        mx: "auto",
      }}
    >
      <CardContent>
        {/* Title + Icon */}
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography
            variant="h6"
            sx={{ color: "#FFC107", fontWeight: "bold", fontSize: "1.1rem" }}
          >
            Test your skill set
          </Typography>
          <Icon
            sx={{
              bgcolor: "transparent",
              color: "#FFC107",
              fontSize: "2rem",
            }}
          >
            <SportsEsportsIcon fontSize="inherit" />
          </Icon>
        </Box>

        {/* Description */}
        <Typography
          variant="body2"
          sx={{ color: "#fff", mt: 1, mb: 2, fontSize: "0.85rem" }}
        >
          Play exciting games to test your skills & view top quality content.
          Get Started now!
        </Typography>

        {/* Button */}
        <Button
          fullWidth
          variant="contained"
          sx={{
            backgroundColor: "#FFC107",
            color: "#000",
            fontWeight: "bold",
            textTransform: "none",
            borderRadius: "10px",
            "&:hover": {
              backgroundColor: "#FFB300",
            },
          }}
          onClick={handlePlayNow} // ✅ trigger game open
        >
          Play Now
        </Button>
      </CardContent>
    </Card>
  );
};

export default SkillCard;
